module.exports = __webpack_public_path__ + "img/work.13c17e00.png";